/* =========================================================
   MY RARE AURA — CART DRAWER INTERACTIONS
   Purpose: AJAX quantity updates, remove animations, cart refresh,
   and recently-added confirmation without breaking Dawn's drawer.
   ========================================================= */
(function () {
  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function refreshCartDrawer(showAddedMessage) {
    const drawer = getCartDrawer();
    if (!drawer) return Promise.resolve();

    drawer.classList.add('aurelle-cart-loading');

    return fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`)
      .then((response) => response.json())
      .then((sections) => {
        const parser = new DOMParser();
        const cartDrawerHtml = sections['cart-drawer'];
        const cartIconHtml = sections['cart-icon-bubble'];

        if (cartDrawerHtml) {
          const newCartDrawer = parser
            .parseFromString(cartDrawerHtml, 'text/html')
            .querySelector('#CartDrawer');

          const currentCartDrawer = document.querySelector('#CartDrawer');
          if (newCartDrawer && currentCartDrawer) {
            currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
          }
        }

        if (cartIconHtml) {
          const newIcon = parser
            .parseFromString(cartIconHtml, 'text/html')
            .querySelector('#cart-icon-bubble');
          const currentIcon = document.querySelector('#cart-icon-bubble');
          if (newIcon && currentIcon) currentIcon.innerHTML = newIcon.innerHTML;
        }

        if (showAddedMessage) {
          drawer.classList.add('aurelle-cart-added');
          setTimeout(() => drawer.classList.remove('aurelle-cart-added'), 1700);
        }
      })
      .catch((error) => console.error('My Rare Aura cart refresh failed:', error))
      .finally(() => drawer.classList.remove('aurelle-cart-loading'));
  }

  function changeLine(line, quantity, trigger) {
    const drawer = getCartDrawer();
    if (!drawer || !line) return;

    if (Number(quantity) === 0 && trigger) {
      const item = trigger.closest('.aurelle-cart-item');
      if (item) item.classList.add('is-removing');
    }

    drawer.classList.add('aurelle-cart-loading');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      })
      .then(() => refreshCartDrawer(false))
      .catch((error) => {
        console.error('My Rare Aura cart line update failed:', error);
        drawer.classList.remove('aurelle-cart-loading');
      });
  }

  document.addEventListener('click', function (event) {
    const qtyButton = event.target.closest('[data-aurelle-qty]');
    if (qtyButton) {
      event.preventDefault();
      changeLine(qtyButton.dataset.line, qtyButton.dataset.quantity, qtyButton);
      return;
    }

    const removeButton = event.target.closest('[data-aurelle-remove]');
    if (removeButton) {
      event.preventDefault();
      changeLine(removeButton.dataset.line, 0, removeButton);
    }
  });

  /* Public helper used by product/quick-view Add to Bag flows. */
  window.AurelleRefreshCartDrawer = refreshCartDrawer;
})();

/* =========================================================
   MY RARE AURA — CART GIFT NOTE + DISCOUNT UI
   No app required. Discount redirects through Shopify's native
   /discount/CODE endpoint after saving cart note/attributes.
   ========================================================= */
(function () {
  'use strict';

  function drawerForm() {
    return document.querySelector('#CartDrawer-Form');
  }

  function discountInput() {
    return document.querySelector('#AurelleDiscountCode');
  }

  function discountMessage() {
    return document.querySelector('[data-aurelle-discount-message]');
  }

  function setMessage(text) {
    var msg = discountMessage();
    if (msg) msg.textContent = text || '';
  }

  function currentDiscount() {
    var input = discountInput();
    return input ? input.value.trim() : '';
  }

  function saveCartExtras() {
    var form = drawerForm();
    if (!form) return Promise.resolve();

    var note = form.querySelector('textarea[name="note"]');
    var gift = form.querySelector('input[name="attributes[Gift wrap]"]');

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        note: note ? note.value : '',
        attributes: {
          'Gift wrap': gift && gift.checked ? 'Yes' : 'No'
        }
      })
    }).catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var apply = event.target.closest('[data-aurelle-apply-discount]');
    if (!apply) return;

    var code = currentDiscount();
    if (!code) {
      setMessage('Enter a code to apply at checkout.');
      return;
    }

    localStorage.setItem('aurelleDiscountCode', code);
    setMessage('Code saved. It will apply at checkout.');
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('#CartDrawer-Form');
    if (!form) return;

    var active = document.activeElement;
    var isCheckout = active && active.getAttribute('name') === 'checkout';
    if (!isCheckout) return;

    var code = currentDiscount() || localStorage.getItem('aurelleDiscountCode') || '';
    var gift = form.querySelector('input[name="attributes[Gift wrap]"]');
    var note = form.querySelector('textarea[name="note"]');
    var needsUpdate = code || (gift && gift.checked) || (note && note.value.trim());

    if (!needsUpdate) return;

    event.preventDefault();
    saveCartExtras().finally(function () {
      if (code) {
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
      } else {
        window.location.href = '/checkout';
      }
    });
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    var input = discountInput();
    var saved = localStorage.getItem('aurelleDiscountCode');
    if (input && saved) input.value = saved;
  });
})();
